import { logEvent } from 'commons/utils/tracking';
import { MENU_SECONDARY_HIRE_PARTNER_CLICK } from 'config/trackingEvents';

export const menuHirePartnerClick = () => {
  logEvent(MENU_SECONDARY_HIRE_PARTNER_CLICK, {});
};
